import { formatHours, formatVND } from "@/lib/format";

interface EmployeePayrollSummaryProps {
  name: string;
  totalHours: number;
  hourlyRate: number;
  totalPay: number;
  isProjected: boolean;
  payslipUrl?: string | null;
}

export function EmployeePayrollSummary({
  name,
  totalHours,
  hourlyRate,
  totalPay,
  isProjected,
  payslipUrl,
}: EmployeePayrollSummaryProps) {
  return (
    <div className="mx-auto max-w-lg px-4 py-8">
      <div className="rounded-3xl bg-white p-8 shadow-xl ring-1 ring-pink-100">
        <div className="text-center">
          <h1 className="mt-3 font-display text-2xl font-black text-gray-900">{name}</h1>
          <p className="mt-1 text-sm text-gray-500">Payroll tuần này</p>
        </div>

        <div className="mt-8 space-y-3">
          <div className="flex justify-between rounded-xl bg-pink-50 p-4">
            <span className="text-sm font-medium text-gray-600">Tổng giờ</span>
            <span className="font-bold text-gray-900">{formatHours(totalHours)}</span>
          </div>
          <div className="flex justify-between rounded-xl bg-pink-50 p-4">
            <span className="text-sm font-medium text-gray-600">Lương / giờ</span>
            <span className="font-bold text-gray-900">{formatVND(hourlyRate)}</span>
          </div>
          <div className="flex justify-between rounded-xl bg-pink-100 p-4">
            <span className="text-sm font-bold text-pink-700">Tổng lương</span>
            <span className="text-lg font-black text-pink-600">{formatVND(totalPay)}</span>
          </div>
        </div>

        {isProjected && (
          <p className="mt-4 text-center text-xs text-gray-400">
            Số liệu tạm tính, chờ quản lý chốt payslip.
          </p>
        )}

        {payslipUrl && (
          <div className="mt-6">
            <a
              href={payslipUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-cta inline-flex w-full items-center justify-center gap-2"
            >
              ⬇ Tải payslip PNG
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
